module.exports = __webpack_public_path__ + "static/media/tech_accepts_job.90d9aae3.png";